// product ingredients icon mobile slider
document.addEventListener("DOMContentLoaded", function () {
  const ingredientsFeatures = document.querySelector(".ingredients-features");
  let flickityInstance = null;

  function initFlickity() {
    if (window.innerWidth <= 768) {
      if (!flickityInstance) {
        flickityInstance = new Flickity(ingredientsFeatures, {
          cellAlign: "left",
          contain: true,
          pageDots: true,
          prevNextButtons: false,
          freeScroll: true,
          groupCells: 2,
          autoPlay: 3000,
          pauseAutoPlayOnHover: true,
          wrapAround: true,
        });
      }
    } else {
      if (flickityInstance) {
        flickityInstance.destroy();
        flickityInstance = null;
      }
    }
  }

  initFlickity();

  let resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      initFlickity();
    }, 250);
  });
});

// Quantity selector for product page
class QuantitySelector {
  constructor(container, isQuickby = false) {
    this.container = container;
    const suffix = isQuickby ? "_quickby" : "";

    this.minusButton = container.querySelector(
      `.quantity-selector__minus${suffix}`
    );
    this.plusButton = container.querySelector(
      `.quantity-selector__plus${suffix}`
    );
    this.input = container.querySelector(`.quantity-selector__input${suffix}`);

    this.bindEvents();
  }

  bindEvents() {
    this.minusButton.addEventListener("click", () => this.updateQuantity(-1));
    this.plusButton.addEventListener("click", () => this.updateQuantity(1));
  }

  updateQuantity(change) {
    const currentValue = parseInt(this.input.value);
    const newValue = Math.max(1, currentValue + change);
    this.input.value = newValue;
    this.input.dispatchEvent(new Event("change"));
  }
}

document.querySelectorAll(".quantity-selector").forEach((container) => {
  new QuantitySelector(container, false);
});

document.querySelectorAll(".quantity-selector_quickby").forEach((container) => {
  new QuantitySelector(container, true);
});

// squeezby video popup on product page
function openVideoPopup(container) {
  const modal = document.getElementById("video-popup-modal");
  const video = document.getElementById("popup-video");
  const videoSource = document.getElementById("popup-video-source");
  const videoUrl = container.getAttribute("data-video-url");

  videoSource.src = videoUrl;
  modal.style.display = "flex";
  document.body.style.overflow = "hidden";
  video.load();
  video.play();
}

function closeVideoPopup(event) {
  const modal = document.getElementById("video-popup-modal");
  const video = document.getElementById("popup-video");

  if (event.target === modal || event.target.classList.contains("close-btn")) {
    video.pause();
    modal.style.display = "none";
    document.body.style.overflow = "auto";
  }
  event.stopPropagation();
}

// more payment icon product page
document.addEventListener("DOMContentLoaded", function () {
  const toggleBtn = document.querySelector(".toggle-icons");
  const hiddenIcons = document.querySelectorAll(
    ".payment-icon-list li.hidden-desktop"
  );

  if (toggleBtn) {
    toggleBtn.addEventListener("click", function () {
      hiddenIcons.forEach((icon) => {
        icon.style.display = "block";
      });
      this.style.display = "none";
    });

    toggleBtn.addEventListener("keypress", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        this.click();
      }
    });
  }
});

// aboutus and home page icon row section mobile slider
class IconsRowSlider {
  constructor(container) {
    this.container = container;
    this.slider = container.querySelector(
      ".icons-row__slider.carousel--mobile"
    );
    // this.flkty = null;
    this.mobileBreakpoint = 768;

    this.sectionId = this.container.id;
    this.cellSelector = this.getCellSelector();

    this.init();

    window.addEventListener("resize", () => this.handleResize());
  }

  getCellSelector() {
    const sectionSelectors = {
      "about-us": "#about-us .icons-row-item",
      "squeezby-online": ".template-index .icons-row-item",
    };
    const sectionName = this.sectionId.split("--")[1];
    return sectionSelectors[sectionName] || ".icons-row-item";
  }
  init() {
    if (window.innerWidth <= this.mobileBreakpoint) {
      this.initMobileSlider();
    } else {
      this.destroyMobileSlider();
    }
  }

  initMobileSlider() {
    if (!this.flkty && this.slider) {
      this.slider.classList.remove("grid--mobile");
      this.slider.classList.add("flickity-enabled");

      this.flkty = new Flickity(this.slider, {
        // cellSelector: this.cellSelector,
        cellAlign: "left",
        contain: true,
        prevNextButtons: false,
        pageDots: true,
        draggable: true,
        adaptiveHeight: false,
        percentPosition: true,
        wrapAround: false,
        friction: 0.8,
        selectedAttraction: 0.2,
        autoPlay: false,
      });

      this.addTouchIndicator();
    }
  }

  addTouchIndicator() {
    if ("ontouchstart" in window) {
      const firstCell = this.slider.querySelector(this.cellSelector);
      if (firstCell) {
        firstCell.setAttribute("data-touch-hint", "true");
        setTimeout(() => {
          firstCell.removeAttribute("data-touch-hint");
        }, 2000);
      }
    }
  }

  destroyMobileSlider() {
    if (this.flkty) {
      this.slider.classList.add("grid--mobile");
      this.slider.classList.remove("flickity-enabled");

      this.flkty.destroy();
      this.flkty = null;
    }
  }

  handleResize() {
    if (window.innerWidth <= this.mobileBreakpoint) {
      if (!this.flkty) {
        this.initMobileSlider();
      }
    } else {
      this.destroyMobileSlider();
    }
  }
}
document.addEventListener("DOMContentLoaded", () => {
  const iconRows = document.querySelectorAll('[data-section-type="icons-row"]');
  iconRows.forEach((section) => new IconsRowSlider(section));
});

// homepage flickty slider for little one
document.addEventListener("DOMContentLoaded", function () {
  function initFlickity() {
    const slider = document.querySelector(".section-columns__slider");

    if (slider) {
      if (slider.classList.contains("flickity-enabled")) {
        const flkty = Flickity.data(slider);
        if (flkty) {
          flkty.destroy();
        }
      }

      if (window.innerWidth <= 767) {
        slider.classList.remove("carousel");
        const flkty = new Flickity(slider, {
          cellAlign: "left",
          contain: true,
          pageDots: true,
          prevNextButtons: false,
          adaptiveHeight: true,
          imagesLoaded: true,
          cellSelector: ".column-item",
          percentPosition: false,
          dragThreshold: 10,
        });
        flkty.on("settle", () => {
          flkty.resize();
        });
      }
    }
  }
  initFlickity();
  let resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initFlickity, 250);
  });
});

// loyalty join-us section js
document.addEventListener("DOMContentLoaded", function () {
  const slides = document.querySelectorAll(".slide");
  const imageSlides = document.querySelectorAll(".image-slide");
  const benefitsList = document.querySelectorAll(".benefits-list");
  let currentSlide = 0;
  let slideInterval;

  function nextSlide() {
    slides[currentSlide].classList.remove("active");
    imageSlides[currentSlide].classList.remove("active");

    currentSlide = (currentSlide + 1) % slides.length;

    slides[currentSlide].classList.add("active");
    imageSlides[currentSlide].classList.add("active");
  }

  function startSlider() {
    slideInterval = setInterval(nextSlide, 800);
  }

  function stopSlider() {
    clearInterval(slideInterval);
  }

  if (slides.length > 0) {
    startSlider();
  }

  benefitsList.forEach((benefit) => {
    benefit.addEventListener("mouseenter", stopSlider);
    benefit.addEventListener("mouseleave", startSlider);
  });
});

// Custom Cart count in menu bar
document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("click", function (e) {
    if (
      e.target.parentElement.className == "cart__item__remove" ||
      e.target.className.baseVal == "icon icon-toggle-minus" ||
      e.target.className.baseVal == "icon icon-toggle-plus" ||
      e.target.className == "cart__item__quantity-minus" ||
      e.target.className == "cart__item__quantity-plus" ||
      (e.target.farthestViewportElement &&
        e.target.farthestViewportElement.className.baseVal ==
          "icon icon-toggle-plus") ||
      (e.target.farthestViewportElement &&
        e.target.farthestViewportElement.className.baseVal ==
          "icon icon-toggle-minus")
    ) {
      setTimeout(function () {
        updateCartCount();
      }, 2000);
    }
  });
  document.addEventListener("keyup", function (e) {
    if (e.target.classList.contains("js-drawer-open-cart")) {
      setTimeout(function () {
        updateCartCount();
      }, 2000);
    }
  });
  function updateCartCount() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((data) => {
        const cartCount = data.item_count;
        // console.log(cartCount,"cartCount");
        document.querySelector(".cart-count-bubble").textContent = cartCount;
        document.querySelector(".mobile-count").textContent = cartCount;
      });
  }
  const addToCartButtons = document.querySelectorAll("[data-add-to-cart]"); // Select all buttons with data-add-to-cart
  addToCartButtons.forEach((button) => {
    button.addEventListener("click", function () {
      setTimeout(function () {
        updateCartCount();
      }, 2000);
    });
  });
  updateCartCount();
});

// variant hide and dropdown selector product page
// document.addEventListener("DOMContentLoaded", (event) => {
//      function setVariant(){
//             const buttonText = document.querySelector('button.select-popout__toggle span.select-popout__value').textContent;

//              const selectoptions= document.querySelectorAll(`.select-popout__list__scroll`);
//              const listItems = document.querySelectorAll('.select-popout__list__scroll .select-popout__item');
//              const availableOptions = Array.from(listItems).filter(item =>
//                !item.classList.contains('unavailable')
//              );
//              document.querySelector('.select-popout').classList.remove("unavailable");
//              availableOptions.forEach((option, index) => {
//              const optionText = option.querySelector('.select-popout__option span').textContent.trim();
//              if (index === 0) {
//                option.classList.add('select-popout__item--current');
//                const buttonText = document.querySelector('button.select-popout__toggle span.select-popout__value').textContent = 'Please select flavour';
//                if (buttonText == 'Please select flavour') {
//                  document.querySelector('.product__form__wrapper').classList.add('variant--unavailabe');
//                  document.querySelector('button.product__submit__add').setAttribute('disabled', 'disabled');
//                  document.querySelector('button.product__submit__add span[data-add-to-cart-text]').textContent = 'Unavailable';
//                }
//              }
//              });

//      }
//      const ageVariants = document.querySelectorAll("[data-variant-buttons] .radio__button [name='options[Age]']");
//      ageVariants.forEach(ageVariant => {
//        const ageLabels = document.querySelectorAll(`label[for="${ageVariant.id}"]`);
//        ageLabels.forEach(ageLabel => {
//          ageLabel.addEventListener("click", () => {
//             setTimeout(function(){
//            setVariant();
//               },100)
//          });
//        });
//      })
// setTimeout(function(){
//      setVariant();
//      },100)
//    });

//Added the preselected flavour selector product page
document.addEventListener("DOMContentLoaded", (event) => {
  function updateURL(variantId) {
    if (!variantId) return;
    const url = new URL(window.location.href);
    url.searchParams.set("variant", variantId);
    window.history.replaceState({}, "", url.toString());
  }
  
  function setVariant() {
    const selectoptions = document.querySelectorAll(
      ".select-popout__list__scroll"
    );
    const listItems = document.querySelectorAll(
      ".select-popout__list__scroll .select-popout__item"
    );
    
    // Make sure we have options to process
    if (!listItems || listItems.length === 0) {
      console.log("No variant options found");
      return;
    }
    
    const availableOptions = Array.from(listItems).filter(
      (item) => !item.classList.contains("unavailable")
    );
    
    // Remove unavailable class from select-popout if it exists
    document.querySelector(".select-popout")?.classList.remove("unavailable");
    
    const firstAvailableOption = availableOptions[0];
    if (firstAvailableOption) {
      firstAvailableOption.click();
      const clickableElement = firstAvailableOption.querySelector(
        ".select-popout__option"
      );
      if (clickableElement) {
        clickableElement.click();
      }
      
      const productFormWrapper = document.querySelector(".product__form__wrapper");
      if (productFormWrapper) {
        productFormWrapper.classList.remove("variant--unavailabe");
      }
      
      const submitButton = document.querySelector(
        "button.product__submit__add"
      );
      if (submitButton) {
        submitButton.removeAttribute("disabled");
        const addToCartText = submitButton.querySelector("span[data-add-to-cart-text]");
        if (addToCartText) {
          addToCartText.textContent = "Add to cart";
        }
      }
    } else {
      console.log("No available options found");
    }
  }
  
  // Check if the current variant is unavailable
  function isCurrentVariantUnavailable() {
    const submitButton = document.querySelector("button.product__submit__add");
    if (submitButton && submitButton.hasAttribute("disabled")) {
      return true;
    }
    
    const productFormWrapper = document.querySelector(".product__form__wrapper");
    if (productFormWrapper && productFormWrapper.classList.contains("variant--unavailabe")) {
      return true;
    }
    
    return false;
  }
  
  // Check if product ID is available in the page
  function isProductIdAvailable() {
    // Look for product ID in meta tags (common implementation)
    const productIdMeta = document.querySelector('meta[property="product:id"], meta[name="product-id"]');
    if (productIdMeta && productIdMeta.getAttribute('content')) {
      return true;
    }
    
    // Alternative: check for product ID in data attributes on the product form
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (productForm && (productForm.getAttribute('data-product-id') || productForm.getAttribute('id')?.includes('product'))) {
      return true;
    }
    
    // Check for product JSON in the page
    const productJSON = document.querySelector('[data-product-json]');
    if (productJSON) {
      return true;
    }
    
    return false;
  }
  
  // Initialize variant selection
  function initVariantSelection() {
    // Only proceed if we have a product
    if (!isProductIdAvailable()) {
      console.log("Product ID not found on page, skipping variant initialization");
      return;
    }
    
    // Set up age variant click handlers
    const ageVariants = document.querySelectorAll(
      "[data-variant-buttons] .radio__button [name='options[Age]']"
    );
    
    ageVariants.forEach((ageVariant) => {
      const ageLabels = document.querySelectorAll(
        `label[for="${ageVariant.id}"]`
      );
      ageLabels.forEach((ageLabel) => {
        ageLabel.addEventListener("click", () => {
          setTimeout(function () {
            // Only run setVariant() if the current variant is unavailable
            if (isCurrentVariantUnavailable()) {
              setVariant();
            }
          }, 100);
        });
      });
    });
    
    // Set up select popout click handler
    const selectPopout = document.querySelector(".select-popout");
    if (selectPopout) {
      selectPopout.addEventListener("click", function (e) {
        const option = e.target.closest(".select-popout__item");
        if (option) {
          const variantId = option.getAttribute("data-value");
          updateURL(variantId);
        }
      });
    }
    
    // On initial load, check if we need to set a variant
    setTimeout(function () {
      if (isCurrentVariantUnavailable()) {
        setVariant();
      }
    }, 100);
  }
  
  // Initialize variant selection
  initVariantSelection();
});

// product variant benefit using metafield
function yagiHideAllBenefitsExceptvaraint(variant) {
  document.querySelectorAll(".yagi-variant-benefits-variant").forEach((el) => {
    el.style.display = "none";
  });
  const benefitsEl = document.querySelector(
    `.yagi-variant-benefits-variant[data-variant-id="${variant}"]`
  );
  if (benefitsEl) {
    benefitsEl.style.display = "block";
  }
}

const queryStringvariant = location.search;
const urlParamsvariant = new URLSearchParams(queryStringvariant);
var variantId = "{{ product.variants.first.id }}";
if (urlParamsvariant.get("variant")) {
  variantId = urlParamsvariant.get("variant");
}
yagiHideAllBenefitsExceptvaraint(variantId);

document.addEventListener("DOMContentLoaded", (event) => {
  document.querySelector("input[type='hidden']")?.addEventListener("change", yagiBenefitsVariantChanged);
});

function yagiBenefitsVariantChanged() {
  if (document.querySelector(".product-variant-id")?.value !== variantId) {
  variantId = document.querySelector(".product-variant-id")?.value;
    if (!variantId) {
      variantId = "{{ product.variants.first.id }}";
    }
    yagiHideAllBenefitsExceptvaraint(variantId);
  }
}

const benefitsObserver = new MutationObserver((mutations) => {
  const urlParamsvariant = new URLSearchParams(window.location.search);
  const variantId = urlParamsvariant.get("variant");
  if (variantId) {
    yagiHideAllBenefitsExceptvaraint(variantId);
  }
});

benefitsObserver.observe(document.body, {
  subtree: true,
  childList: true,
});

// product variant accordion using metafield
(function () {
  let currentVariantId = "{{ current_variant.id }}";

  function updateAccordions(variantId) {
    if (!variantId) return;

    document
      .querySelectorAll(".yagi-variant-accordion")
      .forEach((accordion) => {
        accordion.style.display = "none";
      });

    const selectedAccordion = document.querySelector(
      `.yagi-variant-accordion[data-variant-id="${variantId}"]`
    );
    if (selectedAccordion) {
      selectedAccordion.style.display = "block";
      currentVariantId = variantId;
    }
  }

  document.addEventListener("change", function (event) {
    const variantSelect = event.target.closest("select[data-variant-select]");
    const variantInput = document.querySelector('input[name="id"]');

    if (variantSelect) {
      updateAccordions(variantSelect.value);
    } else if (variantInput && variantInput.value !== currentVariantId) {
      updateAccordions(variantInput.value);
    }
  });

  window.addEventListener("popstate", function () {
    const params = new URLSearchParams(window.location.search);
    const variantId = params.get("variant");
    if (variantId) {
      updateAccordions(variantId);
    }
  });

  const observer = new MutationObserver(function (mutations) {
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput && variantInput.value !== currentVariantId) {
      updateAccordions(variantInput.value);
    }
  });

  observer.observe(document.body, {
    subtree: true,
    attributes: true,
    childList: true,
  });

  const urlParams = new URLSearchParams(window.location.search);
  const initialVariantId =
    urlParams.get("variant") || "{{ current_variant.id }}";
  updateAccordions(initialVariantId);
})();

// Upsell product slider
var elem = document.querySelector(".upsell__products__slider");
if (elem) {
  new Flickity(elem, {
    cellAlign: "left",
    prevNextButtons: false,
    pageDots: true,
    groupCells: true,
    wrapAround: true,
  });
}

// Collection list custom arrows

// document.querySelectorAll(".custom-carousel__arrow").forEach((button) => {
//   button.addEventListener("click", () => {
//     const container = button.closest(".carousel--mobile"); // update if your carousel has a specific class
//     const isPrev = button.classList.contains("carousel__arrow--prev");

//     const scrollAmount = container.offsetWidth;

//     container.scrollBy({
//       left: isPrev ? -scrollAmount : scrollAmount,
//       behavior: "smooth",
//     });
//   });
// });
document.querySelectorAll(".custom-carousel__arrow").forEach((button) => {
  button.addEventListener("click", () => {
    const container = button
      .closest(".list-collections-section__container")
      .querySelector(".carousel--mobile");
    const isPrev = button.classList.contains("carousel__arrow--prev");

    const scrollAmount = container.offsetWidth;

    const targetScroll = isPrev
      ? container.scrollLeft - scrollAmount
      : container.scrollLeft + scrollAmount;

    // Use requestAnimationFrame for smoother fallback if needed
    container.scrollTo({
      left: targetScroll,
      behavior: "smooth",
    });
  });
});
